function isNestedServiceEventItem(item) {
	return Boolean(
		item?.reservation ||
			item?.product ||
			item?.stations ||
			(item?.status && typeof item.status === 'object' && !Array.isArray(item.status)),
	);
}

/**
 * Normaliza un item de service event al formato plano que espera el Copilot.
 * Soporta payload legado y el nuevo anidado (reservation, product, status, stations, dates).
 */
export function normalizeServiceEventItem(item) {
	if (!item || typeof item !== 'object') {
		return item;
	}

	if (!isNestedServiceEventItem(item)) {
		return item;
	}

	const reservation = item.reservation ?? {};
	const product = item.product ?? {};
	const status = item.status ?? {};
	const stations = item.stations ?? {};
	const dates = item.dates ?? {};
	const zone = reservation.zone ?? reservation.roomName;

	return {
		...item,
		productOrderId: item.productOrderId ?? item.id,
		reservationInfo: item.reservationInfo ?? {
			reservationId: reservation.reservationId,
			table: reservation.table,
			zone,
			roomName: zone,
			locationTag: reservation.locationTag ?? '',
			userName: reservation.userName,
			serviceMode: reservation.serviceMode,
			typeName: reservation.typeName,
			reservationName: reservation.reservationName,
			pax: reservation.pax,
		},
		requirementProductCopilotRoles: item.requirementProductCopilotRoles ?? stations.requiredRoles ?? [],
		elaborationStations: item.elaborationStations ?? stations.elaborationStations ?? [],
		statusProductOrder: item.statusProductOrder ?? status.statusProductOrder ?? status.status,
		paymentStatus: item.paymentStatus ?? status.paymentStatus,
		isInvoiced: item.isInvoiced ?? status.isInvoiced,
		isIncludedInMenu: item.isIncludedInMenu ?? status.isIncludedInMenu,
		isVisible: item.isVisible ?? status.isVisible,
		name: item.name ?? product.name,
		shortName: item.shortName ?? product.shortName,
		sku: item.sku ?? product.sku,
		productId: item.productId ?? product.productId,
		type: item.type ?? product.type,
		category: item.category ?? product.category,
		price: item.price ?? product.price,
		unitaryPrice: item.unitaryPrice ?? product.unitaryPrice,
		units: item.units ?? product.units,
		dateCreated: item.dateCreated ?? dates.created,
		datePreparing: item.datePreparing ?? dates.preparing,
		datePrepared: item.datePrepared ?? dates.prepared,
		dateReady: item.dateReady ?? dates.ready,
		dateServed: item.dateServed ?? dates.served,
		dateFired: item.dateFired ?? dates.fired,
		choices: item.choices ?? [],
		priceModifiers: item.priceModifiers ?? [],
		staffComments: item.staffComments ?? null,
		variablePrice: item.variablePrice ?? false,
		shareable: item.shareable ?? null,
		parentId: item.parentId ?? null,
	};
}

export function normalizeServiceEvent(serviceEvent) {
	if (!serviceEvent || typeof serviceEvent !== 'object') {
		return serviceEvent;
	}

	return {
		...serviceEvent,
		items: Array.isArray(serviceEvent.items) ? serviceEvent.items.map(normalizeServiceEventItem) : [],
	};
}

export function normalizeServiceEvents(serviceEvents) {
	if (!Array.isArray(serviceEvents)) {
		return [];
	}

	return serviceEvents.map(normalizeServiceEvent);
}
